import { Box, Button, Flex, Heading, Icon, Text } from "@storyofams/react-ui";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  PinterestIcon,
  PinterestShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { showToast } from "~lib";
import { Link } from "../Icons";
export const Share = ({ url, title }) => {
  return (
    <Box>
      <Heading as="h2" mb="10px">
        {title}
      </Heading>
      <Text mb="10px">Share this via link</Text>
      <Flex justifyContent="space-between" mb="10px">
        <EmailShareButton url={url}>
          <EmailIcon borderRadius={50} size={50} />
        </EmailShareButton>
        <FacebookShareButton url={url}>
          <FacebookIcon borderRadius={50} size={50} />
        </FacebookShareButton>
        <LinkedinShareButton url={url}>
          <LinkedinIcon borderRadius={50} size={50} />
        </LinkedinShareButton>
        <PinterestShareButton media="" url={url}>
          <PinterestIcon borderRadius={50} size={50} />
        </PinterestShareButton>
        <TwitterShareButton url={url}>
          <TwitterIcon borderRadius={50} size={50} />
        </TwitterShareButton>
        <WhatsappShareButton url={url}>
          <WhatsappIcon borderRadius={50} size={50} />
        </WhatsappShareButton>
      </Flex>
      <Text mb="10px">Or copy link</Text>
      <Box
        border={"1px solid black"}
        display="flex"
        py="5px"
        px="10px"
        height={"45px"}
      >
        <Icon mr="8px" icon={Link}></Icon>
        <Text
          width={"75%"}
          whiteSpace={"nowrap"}
          flex="none"
          pt="6px"
          lineHeight={"20px"}
          overflow="hidden"
          css={{ textOverflow: "ellipsis" }}
        >
          {url}
        </Text>
        <Box
          bg="black"
          color={"white"}
          ml="8px"
          onClick={() => {
            navigator.clipboard.writeText(url);
            showToast("Copied!", "info")
          }}
          border="1px solid black"
          borderRadius="xs"
          textAlign={"center"}
          pt="4px"
          fontWeight={600}
          cursor="pointer"
          width={"100%"}
        >
          Copy
        </Box>
      </Box>
    </Box>
  );
};
